import { useGLTF } from "@react-three/drei";
import { MODELS } from "./models.js";

/**
 * Предзагрузка всех GLTF моделей, используемых в проекте
 * Это ускоряет инициализацию сцены, так как модели загружаются заранее
 */
export function preloadModels() {
  // Машина
  useGLTF.preload(MODELS.CAR);

  // Деревья
  useGLTF.preload(MODELS.TREE);
  useGLTF.preload(MODELS.TREE_ALL_COLOR);
  useGLTF.preload(MODELS.TREE_RED);
  useGLTF.preload(MODELS.TREE_YELLOW);
  useGLTF.preload(MODELS.TREE_ORANGE);
  useGLTF.preload(MODELS.MINI_TREE_GREEN);
  useGLTF.preload(MODELS.MINI_TREE_RED);
  useGLTF.preload(MODELS.MINI_TREE_YELLOW);
  useGLTF.preload(MODELS.MINI_TREE_ORANGE);

  // Указатели зон
  useGLTF.preload(MODELS.POINTER_GAME_ZONE);
  useGLTF.preload(MODELS.POINTER_WORK_ZONE);
  useGLTF.preload(MODELS.POINTER_HOBBY_ZONE);

  // Объекты жизни
  useGLTF.preload(MODELS.PLANT);
  useGLTF.preload(MODELS.DUMBBELL);
  useGLTF.preload(MODELS.TELEGRAM);
  useGLTF.preload(MODELS.PIZZA_FINISH);
  useGLTF.preload(MODELS.SNOWBOARD);
}
